import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})

/**
 * NOTHING TO BE CHANGED MANUALLY HERE!
 * ALSO NOT VERSIONING. CHANGE VERSIONING IN UPDATE-HELPER-SCRIPT!
 */
export class StrHlp {
  // changed-by-script vars
  static CLOUD_PATH = "ANIME";
  static APP_NAME = "Anime Hub";
  static APP_URL = "animehub.us";

  static COMMUNITY_NAME = "Anime";
  static COMMUNITY_NAME_2 = "Hentai";
  static COMMUNITY_NAME_3 = "Porn";

  static ALLOWS_NSFW = true;

  static DONATION_URL = "https://buy.stripe.com/bIYfZS310gwl9sAfYZ";
  static DONATION_TEXT = "Our mission is to protect Hentai content. We refuse to censor your speech, and as a result, Google and other ad partners have stopped doing business with us. Be a hero for Hentai and help us stay online.";
  static DONATION_IMAGE_URL = "https://odhub.b-cdn.net/HubData%2FHubImages%2Fads%2Fsystemads%2Fanimehub_donation_ad_1_1100x1100.webp?alt=media&token=a0a86e90-eb44-492f-91af-aa97074ec847";

  static get GO_PREMIUM_AD_TEXT() {
    return `Become a **verified member**! Get a blue check next to your name and remove all ads. Plus, you’ll be helping ${StrHlp.APP_NAME} to become independent of advertising partners.`
  }

  static VERSION_CODE = 317;
  static VERSION_STRING = "5.4.2";
  // --

  // getter methods for accessing in template

  getAppName(): string {
    return StrHlp.APP_NAME
  }
  getCommunityName(): string {
    return StrHlp.COMMUNITY_NAME
  }
  getCloudPath(): string {
    return StrHlp.CLOUD_PATH
  }
  getVersionCode(): number {
    return StrHlp.VERSION_CODE
  }
  getVersionString(): string {
    return StrHlp.VERSION_STRING
  }
  getAllowsNSFW(): boolean {
    return StrHlp.ALLOWS_NSFW
  }
  getDonationText() {
    return StrHlp.DONATION_TEXT
  }
  getDonationImageURL() {
    return StrHlp.DONATION_IMAGE_URL
  }

  // --

  constructor() {}

  // ***************************************************
  // ***************************************************
  // ***************************************************
  /**
   * DEPRECATED STUFF BELOW, NO LONGER USED
   */
  // ***************************************************
  // ***************************************************
  // ***************************************************

  //static ANDROID_APP_IN_PLAY_STORE_LINK: string = "https://play.google.com/store/apps/details?id=org.toedi.";
  //static KEYWORDS_FOR_SEO: string = "";

  //static ANDROID_APP_IN_PLAY_STORE_LINK: string = "https://play.google.com/store/apps/details?id=org.toedi.";

  //static getSiteDesc(): string {
  //return `${StrHlp.APP_NAME} is THE social network for the ${StrHlp.COMMUNITY_NAME} community. On ${StrHlp.APP_NAME}, images and videos are exciting and genuine. ${StrHlp.APP_NAME} makes finding like-minded people, chatting, sharing images & thoughts very simple. From your morning coffee to your evening routine, ${StrHlp.APP_NAME} has the content that is guaranteed to make your day.`;
  //}
}
